import {StorableObject} from '@app/core/storable-object';

export class LearningObject extends StorableObject {

    constructor() {
        super();
    }
}
